module.exports = __webpack_public_path__ + "static/img/3.f79e802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/3.png
// module id = 1JlK
// module chunks = 12